// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	AddressCardIcon: 'address-card-icon',
	CancelIcon: 'cancel-icon',
	IntegratedIcon: 'integrated-icon',
	IntegratedIcon1: 'integrated-icon-1',
	SubmitIcon: 'submit-icon',
	SubmitIcon1: 'submit-icon-1',
	DollarIcon: 'dollar-icon',
	HomeIcon: 'home-icon',
	Link1: 'link-1',
	ToggleShowContactInfoDiv: 'toggle-show-contact-info-div',
	CancelDiv: 'cancel-div',
	OpenPortalDiv: 'open-portal-div',
	OpenPortalDiv1: 'open-portal-div-1',
	OpenFinancialSettingsDiv: 'open-financial-settings-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
